var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    staticClass: "form-control ignore-readonly",
    attrs: { type: "text", "data-input": "" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }